(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.custom-contact').forEach((sectionEl) => {
    const pills = Array.from(sectionEl.querySelectorAll('.custom-contact__pill'));
    const hiddenInput = sectionEl.querySelector('[data-custom-contact-tag-input]');

    let selectedTags = [];

    const updateInput = () => {
      if (!hiddenInput) return;

      if (selectedTags.length === 0) {
        hiddenInput.value = 'pas de catégorie';
      } else {
        hiddenInput.value = selectedTags.join(', ');
      }
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const value = pill.getAttribute('data-tag-value');
        if (!value) return;

        const index = selectedTags.indexOf(value);

        if (index > -1) {
          // remove
          selectedTags.splice(index, 1);
          pill.classList.remove('custom-contact__pill--active');
        } else {
          // add
          selectedTags.push(value);
          pill.classList.add('custom-contact__pill--active');
        }

        updateInput();
      });
    });

    // init
    updateInput();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.timeline-section');
    if (!sections.length) return;

    sections.forEach((section) => {
      const speedAttr = section.getAttribute('data-speed');
      const speed = Number(speedAttr) || 500;

      const points = section.querySelectorAll('.point');
      const durations = section.querySelectorAll('.duration');
      const lines = section.querySelectorAll('.line-right');
      const items = section.querySelectorAll('.item');

      if (!points.length) return;

      let index = 0;

      if (items[0]) {
        items[0].classList.add('is-active');
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            observer.disconnect();

            const animate = () => {
              if (index >= points.length) return;

              const point = points[index];
              const duration = durations[index];
              const line = lines[index];
              const item = items[index];

              if (point) point.classList.add('is-active');
              if (duration) duration.classList.add('is-active');
              if (line) line.classList.add('is-active');
              if (item) item.classList.add('is-active');

              index += 1;

              if (index < points.length) {
                window.setTimeout(animate, speed);
              }
            };

            window.setTimeout(animate, speed);
          });
        },
        { threshold: 0.6 }
      );

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
